import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { loginUser } from '../utils/api';

/**
 * Login page — shown when the user has no valid JWT token.
 */
function LoginPage({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const token = await loginUser(username, password);
      onLogin(token);
    } catch (err) {
      setError(err.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  }

  const inputBase = {
    width: '100%',
    boxSizing: 'border-box',
    padding: '9px 12px',
    border: '1px solid #E2E5EC',
    borderRadius: 6,
    fontSize: '0.875rem',
    color: '#021344',
    background: '#fff',
    outline: 'none',
    transition: 'border-color 0.15s, box-shadow 0.15s',
    fontFamily: 'inherit',
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: '#F8F9FC',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: "'Rubik', sans-serif",
    }}>
      <div style={{
        background: '#fff',
        borderRadius: 16,
        boxShadow: '0 8px 24px rgba(2,19,68,0.10), 0 4px 8px rgba(2,19,68,0.04)',
        padding: '40px 48px',
        width: '100%',
        maxWidth: 400,
        border: '1px solid #E2E5EC',
      }}>
        {/* Logo */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 32 }}>
          <div style={{
            width: 40, height: 40, borderRadius: 10,
            background: '#1F50FF',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: '1.1rem', fontWeight: 700, color: '#fff',
            boxShadow: '0 4px 12px rgba(31,80,255,0.30)',
          }}>R</div>
          <span style={{ fontWeight: 600, fontSize: '1.25rem', color: '#021344', letterSpacing: '-0.01em' }}>
            Remate
          </span>
        </div>

        <h1 style={{ margin: '0 0 6px', fontSize: '1.35rem', fontWeight: 600, color: '#021344' }}>
          Iniciar sesión
        </h1>
        <p style={{ margin: '0 0 28px', fontSize: '0.875rem', color: '#6B7A99', fontWeight: 400 }}>
          Ingresa tus credenciales para acceder al panel.
        </p>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 16 }}>
            <label style={{ display: 'block', fontSize: '0.8125rem', fontWeight: 500, color: '#021344', marginBottom: 6 }}>
              Usuario
            </label>
            <input
              type="text"
              value={username}
              onChange={e => setUsername(e.target.value)}
              autoComplete="username"
              required
              style={inputBase}
              onFocus={e => {
                e.target.style.borderColor = '#1F50FF';
                e.target.style.boxShadow = '0 0 0 3px rgba(31,80,255,0.15)';
              }}
              onBlur={e => {
                e.target.style.borderColor = '#E2E5EC';
                e.target.style.boxShadow = 'none';
              }}
            />
          </div>

          <div style={{ marginBottom: 24 }}>
            <label style={{ display: 'block', fontSize: '0.8125rem', fontWeight: 500, color: '#021344', marginBottom: 6 }}>
              Contraseña
            </label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              autoComplete="current-password"
              required
              style={inputBase}
              onFocus={e => {
                e.target.style.borderColor = '#1F50FF';
                e.target.style.boxShadow = '0 0 0 3px rgba(31,80,255,0.15)';
              }}
              onBlur={e => {
                e.target.style.borderColor = '#E2E5EC';
                e.target.style.boxShadow = 'none';
              }}
            />
          </div>

          {error && (
            <div style={{
              marginBottom: 16,
              padding: '10px 14px',
              borderRadius: 8,
              background: '#FEF2F2',
              border: '1px solid #FECACA',
              color: '#DC2626',
              fontSize: '0.8rem',
              fontWeight: 500,
            }}>
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%',
              padding: '10px',
              background: loading ? '#9AA3B5' : '#1F50FF',
              border: 'none',
              borderRadius: 6,
              color: '#fff',
              fontSize: '0.875rem',
              fontWeight: 500,
              cursor: loading ? 'not-allowed' : 'pointer',
              transition: 'background 0.15s',
              fontFamily: 'inherit',
            }}
            onMouseEnter={e => { if (!loading) e.currentTarget.style.background = '#1840CC'; }}
            onMouseLeave={e => { if (!loading) e.currentTarget.style.background = '#1F50FF'; }}
          >
            {loading ? 'Ingresando…' : 'Ingresar'}
          </button>
        </form>
      </div>
    </div>
  );
}

LoginPage.propTypes = {
  onLogin: PropTypes.func.isRequired,
};

export default LoginPage;
